import { render, staticRenderFns } from "./auxiMaterial.vue?vue&type=template&id=0fc3bd78&scoped=true"
import script from "./auxiMaterial.vue?vue&type=script&lang=js"
export * from "./auxiMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3bd78",
  null
  
)

export default component.exports